var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 716,
    height: 466,
    viewBox: "0 0 716 466",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.711 259.021C137.362 254.783 135.895 251.365 134.729 248.894C133.27 245.814 131.891 242.939 129.412 239.595C126.78 236.039 125.181 233.875 122.108 232.291C118.178 230.267 114.372 230.502 112.641 230.634C109.201 230.891 106.474 232.189 101.017 234.785C98.1501 236.149 99.4189 235.753 92.7162 239.265C90.8095 240.263 88.7414 241.326 86.2408 243.247C83.4908 245.359 82.3688 246.87 82.2588 248.564C82.2001 249.407 82.4201 250.023 82.5888 250.559C83.1681 252.355 83.8208 255.047 84.0848 258.86",
    fill: "#F8EC30"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M701.913 260.019C701.297 249.327 702.192 240.799 703.16 234.866C704.575 226.205 706.152 223.111 704.406 218.425C701.788 211.429 694.36 207.887 687.723 204.726C680.302 201.191 678.461 202.284 669.544 198.001C667.094 196.828 662.658 194.547 657.59 191.027C646.898 183.606 647.096 180.174 640.408 177.827C635.378 176.06 630.963 176.493 624.964 177.079C616.898 177.864 610.855 180.299 608.523 181.311C603.412 183.54 603.771 184.354 597.068 187.537C591.055 190.389 588.041 191.819 583.868 192.516C575.977 193.836 571.893 191.394 569.421 194.261C567.691 196.271 569.333 197.891 567.676 201.235C565.417 205.782 561.186 205.181 557.468 209.207C555.495 211.341 554.711 215.227 553.237 222.905C552.357 227.481 551.345 232.805 550.831 240.337C550.494 245.25 550.333 251.505 550.831 258.765",
    fill: "#F8EC30"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.284 258.692C514.318 253.478 514.531 249.65 515.125 247.068C515.69 244.612 516.452 243.952 517.618 239.926C518.506 236.846 519.32 234.052 519.276 230.957C519.217 226.381 517.318 223.103 514.458 218.175C511.407 212.91 510.879 213.841 507.484 208.216C503.832 202.159 503.978 200.304 500.678 196.762C497.899 193.777 495.046 192.141 493.704 191.445C492.062 190.594 486.994 188.049 480.585 188.622C476.449 188.988 476.728 190.213 469.46 191.775C465.009 192.736 462.721 193.205 459.663 192.772C458.739 192.64 457.338 192.369 450.533 189.45C445.238 187.177 444.483 186.656 442.73 185.967C436.592 183.554 430.894 184.119 427.286 184.471C417.76 185.409 416.286 188.973 400.805 194.019C394.191 196.175 390.876 197.253 388.104 197.26C387.437 197.26 385.581 197.224 383.374 198.008C383.374 198.008 381.13 198.808 379.143 200.502C376.224 202.988 375.417 227.84 377.647 261.772",
    fill: "#F8EC30"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M340.524 257.526C340.986 251.703 340.384 247.801 340.025 243.577C339.123 232.885 340.986 234.015 339.776 230.377C337.238 222.758 330.77 222.905 324.332 211.949C322.931 209.565 323.342 209.734 321.34 206.221C317.24 199.005 315.187 195.397 311.381 192.772C306.123 189.149 300.278 189.076 297.433 189.039C292.688 188.981 291.442 190.11 286.228 190.785C279.488 191.65 274.348 190.682 268.298 189.538C256.557 187.323 253.609 184.126 246.628 185.307C242.227 186.047 237.659 187.8 237.659 187.8C234.579 188.981 234.307 189.435 231.682 190.543C228.529 191.863 222.728 194.297 216.253 193.535C211.706 192.999 206.976 191.503 204.233 196.255C198.572 206.06 198.125 221.841 198.308 232.885C198.711 257.115 197.941 257.24 199.056 259.036C204.497 267.829 221.826 263.15 246.378 261.779C294.712 259.08 337.026 271.107 340.025 261.779C340.238 261.112 340.333 259.924 340.524 257.548V257.526Z",
    fill: "#F8EC30"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M136.672 260.518C136.188 258.948 135.396 256.836 134.054 254.541C131.304 249.833 127.923 247.171 126.955 246.445C124.917 244.905 121.125 242.052 115.75 241.59C112.824 241.341 110.228 242.089 105.043 243.585C100.929 244.773 98.1424 245.99 95.7004 247.068C88.3964 250.302 87.2525 252.011 86.8565 252.671C85.2578 255.333 85.2357 258.486 85.2357 258.648C85.2357 259.836 85.4264 260.818 85.6097 261.515",
    fill: "#F8EC30"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.2056 141.967H709.387V263.458H53.2056V141.967Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M696.185 261.266C698.011 252.532 698.018 245.294 697.681 240.344C697.226 233.715 696.837 228.926 693.449 224.651C690.787 221.307 687.458 219.745 682.493 217.926C666.455 212.037 653.849 210.702 653.849 210.702C638.501 209.074 639.3 211.289 623.467 209.954C604.789 208.385 601.504 205.122 594.574 208.458C586.735 212.235 589.111 217.295 578.133 223.903C572.889 227.063 566.201 229.601 561.94 233.37C561.515 233.751 559.124 235.893 555.714 238.599C554.314 239.706 553.749 240.109 553.47 240.344C551.41 242.053 550.053 246.724 553.221 259.77",
    fill: "#F8EC30"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M513.117 259.769C512.582 255.626 511.453 249.752 508.886 243.086C506.884 237.908 505.263 233.692 501.912 229.885C497.578 224.965 493.346 224.121 479.743 219.428C459.628 212.483 462.546 212.124 454.34 210.21C442.101 207.357 432.436 207.409 426.694 207.467C418.906 207.555 414.014 207.651 407.766 209.711C403.344 211.171 404.29 211.618 394.816 215.439C389.521 217.573 387.02 218.328 384.358 220.917C381.469 223.725 380.31 226.827 379.628 228.639C375.096 240.71 379.503 260.319 380.127 263.01",
    fill: "#F8EC30"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M337.789 258.523C336.843 255.128 335.435 251.029 333.308 246.57C332.714 245.331 330.529 240.835 326.334 234.866C319.529 225.179 316.126 220.338 310.392 218.674C307.774 217.918 304.994 217.919 299.436 217.926C292.843 217.933 292.462 218.754 289.477 218.175C283.471 217.016 283.64 213.452 277.025 210.952C271.921 209.023 267.11 209.368 262.329 209.705C260.393 209.844 257.885 210.292 252.862 211.201C241.663 213.218 242.045 213.687 239.163 213.694C231.199 213.716 229.82 210.167 225.215 211.7C222.509 212.602 223.271 213.731 215.997 221.167C212.293 224.959 211.113 225.663 205.789 231.126C203.163 233.825 201.843 235.174 201.308 235.856C199.24 238.489 195.918 245.067 201.308 261.259",
    fill: "#F8EC30"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M51.868 90.6622V263.011H711.371V90.6622V0",
    stroke: "white",
    strokeWidth: 7.33335,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M711.371 159.897H670.033V141.967H550.983V159.897H508.641V141.967H377.638V159.897H334.297V141.967H196.819V159.897H158.466V141.967H51.868",
    stroke: "white",
    strokeWidth: 7.33335,
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M550.816 263.011V162.06",
    stroke: "white",
    strokeWidth: 7.33335,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M377.637 263.011V162.06",
    stroke: "white",
    strokeWidth: 7.33335,
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M196.816 263.011V162.06",
    stroke: "white",
    strokeWidth: 7.33335,
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M462.816 84.4355H145.268",
    stroke: "#F8EC30",
    strokeWidth: 3.66668,
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M707.387 264.499H554.714",
    stroke: "#F8EC30",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M518.438 264.499H381.619",
    stroke: "#F8EC30",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M342.109 264.499H200.972",
    stroke: "#F8EC30",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M142.035 264.499H82.5103",
    stroke: "#F8EC30",
    strokeWidth: 11,
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M51.8672 266.678V463.93H-0.00160087",
    stroke: "#F8EC30",
    strokeWidth: 3.66668,
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M162.703 116.812H192.836V155.914H162.703V116.812Z",
    fill: "#17375E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M338.29 116.812H373.82V155.914H338.29V116.812Z",
    fill: "#17375E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M512.372 116.812H547.242V156.332H512.372V116.812Z",
    fill: "#17375E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M672.517 116.812H707.387V156.332H672.517V116.812Z",
    fill: "#17375E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.0ff439de6d57c34fb14b77a6b8d50f73.svg";
export { ForwardRef as ReactComponent };